import React, { Component } from 'react';
import { Container, Row, Col, Breadcrumb } from 'react-bootstrap';
import { Styles } from "./styles/breadcrumb.js";
import {Helmet} from "react-helmet";

export class BreadcrumbBox extends Component {
    state = {
        backgroundImage: 'breadcrumb-bg.png',
    }

    render() {
        return (
            <Styles>

             <Helmet>
                <meta charSet="utf-8" />
                <title>KTO Teknoloji Transfer Ofisi - {this.props.title}</title>
            </Helmet>

                <section className="breadcrumb-area" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/${this.state.backgroundImage})` }}>
                    <Container>
                        <Row>
                            <Col md="12" className="text-center">
                                <div className="breadcrumb-box">
                                    <h2 className="breadcrumb-title">{this.props.title}</h2>
                                    <Breadcrumb>
                                        <Breadcrumb.Item>Anasayfa</Breadcrumb.Item>
                                        <Breadcrumb.Item active>{this.props.title}</Breadcrumb.Item>
                                    </Breadcrumb>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </Styles>
        )
    }
}